<!-- 会员升级礼 -->
<template>
  <!-- 活动条件表单设置 -->
  <div class="secondstep">
    <jd-tip style="margin: 12px 0">
      <div>
        云短信CRM ：订购到期时间 {{ jdCrm.endTime }}（店铺需要搭配云短信CRM使用）。
      </div>
    </jd-tip>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="125px">
      <informationForm 
        v-model="ruleForm"
        needNonMember
        :defaultActivityStartTime="activityStartTime"
        :defaultActivityEndTime="activityEndTime"
        :defaultActMember.sync="actMember"
        :plusObject.sync="ruleDto.plusObject"
        :openCardStartTime.sync="ruleDto.openCardStartTime"
        :openCardEndTime.sync="ruleDto.openCardEndTime"
        :peopleSelected.sync="peopleSelected"
        :disabled="activityData.isStart || backgroundOpacity"
        @selectPeopleSure="selectPeopleSure"
        @activityTimeChange="activityTimeChange({
          startTime: ruleForm.startTime,
          endTime: ruleForm.endTime
        })"
        :customerPaperwork="customerPaperwork"
        @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
      />
      <!-- 基本信息 -->
      <!-- <basic-info-form v-model="ruleForm" :activity-data="activityData" :background-opacity="backgroundOpacity"
        :level-list="levelList" :people-selected="peopleSelected" :rule-dto="ruleDto" :startTime="activityStartTime"
        :endTime="activityEndTime" :objectType="actMember" @changeActMember="changeActMember"
        @activity-time-change="activityTimeChange" @clear-time="clearTime" @clear-new-time="clearNewTime"
        @check-list-change="checkListchange" @open-crowd="openCrowd" /> -->

      <!-- 活动规则设置 -->
      <activity-rule-settings v-model="ruleForm" :activity-data="activityData" :background-opacity="backgroundOpacity"
        :level-list="levelList" :prize-setting-list-level="prizeSettingListLevel" :level-index="levelIndex"
        :isCopy="activityData.isCopy" :isDraftEdit="isDraftEdit" @check-customer-change="checkCustomerchange"
        @level-click="levelClick" @select-prize="centerVis" @delete-setting="deleteSetting" @move-up-goods="upLvGoods"
        @move-down-goods="downLvGoods" @upload-prize-iamge="upPrizeImage" @add-count="addCount"
        @add-setting="addSetting" @show-select-act="isShowSelectAct = true" @equity-del="equityDel"
        @move-up-equity="upEquity" @move-down-equity="downEquity" @add-equity="addEquity"
        @get-number-data="getNumberData" />
      <activityPageSettings 
        isShowShopName
        isShowMoreSet
        v-model="ruleForm"
        defaultTitleKey="theme"
        defaultDescKey="description"
        defaultTitleColorKey="wordColor"
        previewKey="imageUrl"
        :giftList="giftList"
        :templateId="templateId"
        :isNeedSetBG="false"
        :previewImage="customeLevelSeting && customeLevelSeting[levelIndex] && customeLevelSeting[levelIndex].bgImg"
        @selectTemplate="templateId = giftList[$event].id"
      >
      <template #otherSet>
        <el-form-item label="活动页配置：">
          <div>
            <div class="setting-level">
              <div :class="[
                'setting-level-item',
                { 'setting-level-item__active': levelIndex == index },
              ]" v-for="(item, index) in getChooseCustomer" :key="item.value" @click="levelClick(index)">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div class="custome-level" v-if="customeLevelSeting.length > 0">
            <div class="custome-level-item">
              <span>活动背景图：</span>
              <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                :before-upload="(file) => beforeUpload(file,750,1886)"  :on-success="(res) => handleUpload(res,levelIndex,'bgImg')">
                <div style="width: 80px;height: 150px;overflow: hidden;" v-if="customeLevelSeting[levelIndex].bgImg">
                  <img :src="customeLevelSeting[levelIndex].bgImg" style="width: 100%;height: auto;" />
                </div>
                <jd-button v-else type="blue">自定义上传</jd-button>
              </el-upload>
              <jd-button type="blueText" class="ml10" @click="customeLevelSeting[levelIndex].bgImg = ''; $forceUpdate();">重置</jd-button>
              <jd-button type="blueText" @click="downloadTemplate('https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/membershipUpgrade.psd')">下载模板</jd-button>
              <jd-button type="blueText" @click="isShowDesignSpecifications = true">查看设计规范</jd-button>
            </div>
            <div class="custome-level-item">
              <span>按钮设置：</span>
              <div class="customebtn-box">
                <div class="flexc-cen-x mb16">
                  <span>背景：</span>
                  <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                    :before-upload="(file) => beforeUpload(file,602,88)"  :on-success="(res) => handleUpload(res,levelIndex,'btnImg')">
                    <div style="width: 123px;height: 20px;overflow: hidden;" v-if="customeLevelSeting[levelIndex].btnImg">
                      <img :src="customeLevelSeting[levelIndex].btnImg" style="width: 100%;height: auto;" />
                    </div>
                    <jd-button v-else type="blue">自定义上传</jd-button>
                  </el-upload>
                  <jd-button type="blueText" class="ml10" @click="customeLevelSeting[levelIndex].btnImg = ''; $forceUpdate();">重置</jd-button>
                  <span class="ml10" style="color: #999;">尺寸建议：602px * 88px</span>
                </div>
                <div class="flexc-cen-x">
                  <span>文字：</span>
                  <el-color-picker v-model="customeLevelSeting[levelIndex].btnTextColor"></el-color-picker>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </template>
      </activityPageSettings>
      <!-- 活动页设置 -->
      <!-- <activity-page-settings v-model="ruleForm" :background-opacity="backgroundOpacity" :activityData="activityData"
        @text-color-reset="textColorReset" /> -->

      <!-- 曝光商品 -->
      <exposureList 
        v-model="itemListFor"
        :defaultExposureSwitch.sync="ruleForm.exposureSwitch"
        :backgroundOpacity="backgroundOpacity"
      />
      <!-- <jd-title label='曝光商品' type="bold"></jd-title>
      <el-form-item label="曝光商品:" class="zindexBox">
        <el-checkbox v-model="ruleForm.exposureSwitch" @change="exposureSwitchChange" :disabled="backgroundOpacity"
          :activityData="activityData">
          是否添加曝光商品
        </el-checkbox>
        <el-button style="width: 155px; margin: 0 15px; display: inline-block"
          :class="{ add_btn1: ruleForm.exposureSwitch }" @click="exposureProducts" :disabled="ruleForm.exposureSwitch == false || backgroundOpacity
            ">
          {{
            itemListFor.length != ""
              ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
              : "添加曝光商品"
          }}
        </el-button>
        <el-radio-group v-model="ruleForm.radio" :disabled="ruleForm.exposureSwitch == false || backgroundOpacity
          ">
          <el-radio :label="0">显示京东价</el-radio>
        </el-radio-group>
        <draggable v-if="itemListFor.length > 0" v-model="mainImagelist" chosen-class="chosen" :scroll="true"
          animation="150" force-fallback="true" @start="isDragging = true" @end="onEnd" style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px;
              " filter=".unmover">
          <transition-group type="transition">
            <div v-for="(item, index) in mainImagelist" :key="item.skuId"
              style="display: inline-block; position: relative" class="show_upImg2"
              :class="backgroundOpacity ? 'unmover' : ''">
              <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
              <div class="delectPosible" v-if="!backgroundOpacity">
                <span class="delectSort">拖动排序</span>
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg" @click.stop="delec(index)" class="delectIcom" />
              </div>
            </div>
          </transition-group>
        </draggable>
      </el-form-item> -->

      <!-- 分享设置 -->
      <sharFrom 
        v-model="ruleForm"
      />
      <!-- <share-settings v-model="ruleForm" :activity-data="activityData" :background-opacity="backgroundOpacity"
        :default-share-pic="sharePic" @input-change="inp" /> -->

      <!-- 活动规则 -->
      <newActivityRules 
        v-model="ruleForm.ruleDescription"
        :isForceRemind.sync="ruleDto.isForceRemind"
        :isKeyActivity.sync="isKeyActivity"
        :placementPosition.sync="placementPosition"
        :backgroundOpacity="backgroundOpacity"
        :activityData="activityData"
        :valueRow="valueRow"
        @generateRule="generateRule"
      />
      <!-- <activity-rules v-model="ruleForm" :background-opacity="backgroundOpacity" :activityData="activityData"
        @generate-rule="generateRule" /> -->
    </el-form>

    <!-- 添加曝光商品弹窗 -->
    <selectGoodsMonitor v-if="selectGoodsState" ref="selectGo" :isShow="selectGoodsState" @close="selectGoodsClose"
      :selectGoods="selectGoodsArr" :moduleType="true" :skuSearch="true" :xianz="true" :isLimit="true" :limitNum="20"
      :disabled="backgroundOpacity" >
    </selectGoodsMonitor>

    <!-- 选择奖品弹窗 -->
    <selectProduct ref="selectProduct" v-if="isSelectProduct" :echoDate="echoDate" :actId="valueRow" :num="1" :actType="44" :actEndTime="ruleForm.endTime"
      :JingdouCount="JingdouCount" @choose-shop="getTheData" @close="productClose">
    </selectProduct>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>
      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 选择人群弹窗 -->
    <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList"
      @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople>
    <!-- 添加权益弹窗 -->
    <add-equity :visible.sync="addEquityVisible" :selectedEquities="selectedEquities" @confirm="handleEquityConfirm"
      @close="addEquityVisible = false"></add-equity>
    <!-- 增加库存弹窗 -->
    <el-dialog title="增加奖品库存" :visible.sync="addStockVisible" width="500px">
      <jd-tip color="gley" style="margin: 12px 0">
        <div>
          进行中的活动仅支持增加库存，不支持减少库存
        </div>
      </jd-tip>
      <el-form :model="addStockForm" label-width="100px">
        <el-form-item label="增加数量:" required>
          <el-input v-model="addStockForm.addAmount" @input="addAmountInput()" type="number" placeholder="请输入增加数量"
            style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="addStockVisible = false">取 消</jd-button>
        <jd-button type="blue" @click="confirmAddStock">确认增加</jd-button>
      </div>
    </el-dialog>
    <el-dialog
      title="设计规范"
      :visible.sync="isShowDesignSpecifications"
      width="800px"
    >
      <img style="width: 760px;object-fit: cover;" src="https://cdn-image.yucrm.cn/9506a309097d47b78a61bad5fb85a57c.png"/>
    </el-dialog>
  </div>

</template>
<script>
import informationForm from "../informationForm.vue"
import activityPageSettings from "../activityPageSettings.vue"
import exposureList from "../exposureList.vue"
import sharFrom from "../sharFrom.vue"
import newActivityRules from "../activityRules.vue"
import selectProduct from "../../select_product_componentization.vue";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";

import { saveMemberLevelGift, getMemberLevelGift } from "@/api/jhk/paradiseAndTaskCommonController.js";
import selectPeople from "@/components/select-people-yunqi.vue";
import BasicInfoForm from './components/BasicInfoForm.vue'
import ActivityRuleSettings from './components/ActivityRuleSettings.vue'
import ActivityPageSettings from './components/ActivityPageSettings.vue'
import ShareSettings from './components/ShareSettings.vue'
import ActivityRules from './components/ActivityRules.vue'
import AddEquity from './components/AddEquity.vue';
import { checkPrizeStock } from "@/api/jhk/integralCenter/integralTask.js";
import { publicOpen } from "@/api/jhk/public";
import {useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  name: "create",
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    BasicInfoForm,
    ActivityRuleSettings,
    ActivityPageSettings,
    ShareSettings,
    ActivityRules,
    AddEquity,
    informationForm,
    activityPageSettings,
    exposureList,
    sharFrom,
    newActivityRules
  },
  props: {
    itemId: "",
    partnerTemplateId: "",
    // 选择的模板
    selectTemplate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    ids: '',
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
    // 模板列表
    giftList: {
      type: Array,
      default: ()=> []
    }
  },
  computed: {
    // 获取活动对象-会员身份
    getChooseLevel() {
      if (this.ruleForm.partner.includes("-1")) {
        return this.levelList
      } else {
        return this.levelList.filter(item => this.ruleForm.partner.includes(item.value))
      }
    },
    // 获取可领奖等级
    getChooseCustomer() {
      if (this.ruleForm.memberLevels.includes("-1")) {
        return this.levelList;
      } else {
        return this.levelList.filter((item) => this.ruleForm.memberLevels.includes(item.value)
        );
      }
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    // 是否为保存草稿或编辑草稿
    isDraftOrDraftEdit() {
      return this.isDraftEdit || this.isDraft;
    },
    // 是否需要校验参数
    isCheckedParams() { // 当点击保存并完成设置时，需要校验参数
      return this.isSaveAndFinish;
    }
  },
  watch: {
    getChooseCustomer: {
      handler(val) {
        if (val && val.length > 0) {
          const arr = val || [];
          console.log("getChooseCustomer",arr);
          this.customeLevelSeting = arr.map( (v,index) => {
            const item = this.customeLevelSeting[index] || {};
            return {
              ...v,
              ...item,
              btnTextColor: item.btnTextColor || '#ffffff',
            }
          })
        }
      },
      immediate: true
    },
    valueRow: {
      handler(val) {
        if (val) {
          this.$emit("changevalueRow", val);
        }
      },
    },
    partnerTemplateId: {
      handler: function(val) {
        if(val) {
          this.templateId = this.partnerTemplateId;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.publicOpen();
  },
  data() {
    return {
      customerPaperwork: {},
      isShowDesignSpecifications: false,
      uploadSize: false,
      customeLevelSeting: [],
      isKeyActivity: 0,
      placementPosition: [],
      templateId: "",
      jdCrm:{
        endTime:'',
      },
      params: {}, // 请求参数
      isShowTip: false,
      ruleDto: {
        openCardStartTime: '',
        openCardEndTime: '',
        plusObject: 0, // plus会员 0:不限 1:plus会员 2:非plus会员
        isForceRemind: false,
        cusTemplateJSON: {},
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleDto.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf();
        },
      },
      isSelectProduct: false,
      mainImagelist: [],
      itemArr: [],
      navItem: {},
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },

      selectGoodsArr: [],
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      valueRow: null,
      echoDate: {},
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          } else {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.startTime).valueOf()
          } else {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      joinBlackList: false,
      checked: false,
      winningRate: 0,

      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
      },
      ruleForm: {
        // 是否曝光商品
        exposureSwitch: false,
        radio: 0,
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false, // 活动条件
        ruleDescription: "",
        partner: ["-1"],
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        settingType: 2,
        memberLevels: ["-1"], // 可领奖等级
        limitPerPerson: '', // 每人领奖限制
        theme: "会员升级礼", // 活动主题
        description: "升级会员领好礼",// 活动说明
        wordColor: "#1A1A1A", // 文字颜色
        firstOpenCardTimeType: 0,
        openCardBeforeDay: "",
        openCardFollow: 0,
        isValidBlackList: 0, // 是否开启黑名单 0:关闭 1:开启
      },
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        {
          prizeType: null,
          price: null,
          totalAmount: null,
          percentage: null,
        },
      ],
      prizeSettingListLevel: [],
      index: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时

      levelList: [],
      levelIndex: 0,
      uploadSize: false,
      priceImg: 'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/prizeShow.png',//默认产品图
      isDraft: false,
      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [], // 基本信息-指定人群
      tableIndex: 0,

      // 控制添加权益弹窗
      addEquityVisible: false,
      // 已选择权益(用于回显)
      selectedEquities: [],
      // 新增权益弹窗-当前选择的权益项
      currentGradeItem: null,

      // 增加库存弹窗相关数据
      addStockVisible: false,
      addStockForm: {
        addAmount: '',
      },
      currentPrizeIndex: -1,
      currentPrizeRow: null,

      // 是否点击保存并完成设置
      isSaveAndFinish: false,
    };
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品品卡";
      }
      return result;
    },
  },
  async created() {
    console.log("当前玩法id", this.activityData.id);
    this.sharePic = 'https://cdn-image.yucrm.cn//hd/images/13315956_cc01b0b19351425c86ec0f4c53e84b4f.png';
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
    await this.getLevel();
    this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
  },
  methods: {
    downloadTemplate(url) {
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = url; 
      a.setAttribute("download", name); //
      // 将生成的URL设置为a.href属性
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    beforeUpload(file,widthNumber,heightNumber){
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        console.log("this.widthNumber*this.heightNumber",widthNumber,heightNumber)
        const valid = (image.width == widthNumber && image.height == heightNumber)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if (valid) {
        } else {
            _this.$message.info('图片宽高不符合要求,请重新上传')
            sizetype = false
            return false
        }
      }
      image.src = _URL.createObjectURL(file)
      const isLt3M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
          this.$message.info("上传图片大小不能超过 1MB");
          return false
      }
      if (sorts.indexOf(type) < 0) {
          this.$message.info("所选文件格式不符，请重新选择");
          return false;
      }
    },
    handleUpload(res,levelIndex,typeKey){
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (this.uploadSize) {
          this.customeLevelSeting[levelIndex][typeKey] = res.data;
          this.$forceUpdate();
        }
      }
    },
    // 获取会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push({
              name: item.customerLevelName,
              value: String(item.customerLevel)
            });
          });
          this.prizeSettingListLevel = res.data.map((item) => {
            return {
              customerLevel: String(item.customerLevel),
              name: item.customerLevelName,
              settingList: [
                {
                  taskIndex: String(item.customerLevel),
                  prizeType: null,
                  price: null,
                  totalAmount: null,
                  percentage: null,
                  // 领取条件
                  highLevelGetFlag: true,
                  upgradeGetFlag: true,
                  downgradeGetFlag: true,
                },
              ],
            };
          });
          // 获取详情
          this.getDetail();
        })
        .catch((res) => { });
    },
    orderFocus() {
      if (this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    // 点击选择会员等级
    levelClick(index) {
      console.log("--- index:点击选择会员等级---", index)
      this.levelIndex = index;
    },
    // 重置背景图
    inp(val) {
      this.ruleForm.sharePic = this.sharePic;
      this.$forceUpdate();
    },

    // 活动对象更改
    changeActMember(val) {
      this.actMember = val;
    },

    // 活动对象-会员身份选中改变
    checkListchange(val) {
      // 重置选中状态
      this.levelIndex = 0
      // 当全部取消勾选时 勾选全部
      if (this.ruleForm.partner.length == 0) {
        this.ruleForm.partner = ["-1"];
        // 当勾选了别的选项却再次勾选全部时 勾选全部
      } else if (this.ruleForm.partner.length > 1 && (this.ruleForm.partner[this.ruleForm.partner.length - 1] == -1)) {
        this.ruleForm.partner = ["-1"];
        // 当勾选了除全部以外的所有选项时 勾选全部(这里面多了一个非会员所以要 +1)
      } else if (val.length == this.levelList.length + 1) {
        this.ruleForm.partner = ["-1"];
      } else {
        this.ruleForm.partner = val.filter((item) => item != "-1");
      }
    },

    // 可领奖等级选中改变
    checkCustomerchange(val) {
      console.log("--- val:---", val)
      // 重置选中状态
      this.levelIndex = 0;
      let levelArr = [];
      // 当全部取消勾选时 勾选全部
      if (this.ruleForm.memberLevels.length == 0) {
        this.ruleForm.memberLevels = ["-1"];
        levelArr = this.levelList;
        // 当勾选了别的选项却再次勾选全部时 勾选全部
      } else if (this.ruleForm.memberLevels.length > 1 && (this.ruleForm.memberLevels[this.ruleForm.memberLevels.length - 1] == -1)) {
        this.ruleForm.memberLevels = ["-1"];
        levelArr = this.levelList;
        // 当勾选了除全部以外的所有选项时 勾选全部
      } else if (val.length == this.levelList.length) {
        this.ruleForm.memberLevels = ["-1"];
        levelArr = this.levelList;
      } else {
        this.ruleForm.memberLevels = val.filter((item) => item != "-1");
        levelArr = this.levelList.filter((item) => val.includes(item.value));
        console.log("--- levelArr :---", levelArr)
      }

      this.prizeSettingListLevel = levelArr.map(level => {
        const index = this.prizeSettingListLevel.findIndex(item => item.customerLevel == level.value)
        // 已存在
        if (index != -1) {
          return this.prizeSettingListLevel[index]
        } else {
          return {
            customerLevel: level.value,
            name: level.name,
            settingList: [
              {
                taskIndex: level.value,
                prizeType: null,
                price: null,
                totalAmount: null,
                percentage: null,
                // 领取设置
                highLevelGetFlag: true,
                upgradeGetFlag: true,
                downgradeGetFlag: true,
              },
            ],
          };
        }
      })
      console.log("--- this.ruleForm.memberLevels:---", this.ruleForm.memberLevels)
    },

    //选择奖品弹窗
    centerVis(row, index) {
      this.tableIndex = index;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.isSelectProduct = true
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      })
    },
    // 关闭奖品弹窗
    productClose() {
      this.isSelectProduct = false
    },

    // 获取奖品
    getTheData(data, prizeType) {
      console.log("--- data, prizeType:---", data, prizeType)
      if (prizeType == 1) {
        this.echoDate.couponType = data.couponType;
      }
      if (data.giftType) {
        this.echoDate.giftType = Number(data.giftType);
      }
      this.echoDate.price = Number(data.discount);
      this.echoDate.assetsId = Number(data.couponId || data.skuId);
      this.$set(this.echoDate, "logo", data.logo ? data.logo : this.priceImg);
      this.echoDate.prizeType = prizeType;
      if (prizeType == 4) {
        this.echoDate.title = data.discount + "店铺积分";
      } else {
        this.echoDate.title = data.name;
      }
      if (data.singleAmount) {
        this.echoDate.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.echoDate.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.echoDate.skuId = data.skuId;
          delete this.echoDate.isGoodManage
        } else {
          this.echoDate.isGoodManage = data.isGoodManage;
        }
        this.echoDate.addressFillEndTime = data.addressFillEndTime;
        this.echoDate.isFollowActivityEndTime = data.isFollowActivityEndTime;
        this.echoDate.predictSendTime = data.predictSendTime;
        this.echoDate.shouldCollectExtraData = data.shouldCollectExtraData;
        this.echoDate.extraQuestion = data.extraQuestion;
        this.echoDate.addressFillLimit = data.addressFillLimit;
        this.echoDate.commitAddressLimit = data.commitAddressLimit;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.echoDate,prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.echoDate.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.echoDate.budgetRemain = data.budgetRemain;
      }
      console.log("--- this.prizeSettingListLevel:---", this.prizeSettingListLevel)
    },

    // 添加权益
    addEquity(data) {
      this.currentGradeItem = data;
      this.addEquityVisible = true;
      this.selectedEquities = data.gradeEquityList || [];
    },
    // 处理添加权益
    handleEquityConfirm(selectedEquities) {
      console.log('选择的权益:', selectedEquities);
      if (this.currentGradeItem) {
        // 获取当前已有的权益列表
        const currentEquities = this.currentGradeItem.gradeEquityList || [];
        // 合并现有权益和新选择的权益
        const mergedEquities = [...currentEquities];
        // 添加新选择的权益（通过id去重）
        selectedEquities.forEach(newEquity => {
          // 检查是否已存在相同id的权益
          const existingIndex = mergedEquities.findIndex(item => item.id === newEquity.id);
          if (existingIndex === -1) {
            // 如果不存在，则添加
            mergedEquities.push(newEquity);
          } else {
            // 如果已存在，则更新
            mergedEquities[existingIndex] = newEquity;
          }
        });
        // 更新权益列表
        this.$set(this.currentGradeItem, 'gradeEquityList', mergedEquities);
        this.addEquityVisible = false;
      }
    },
    // 删除权益
    equityDel(index, item) {
      item.gradeEquityList.splice(index, 1);
      console.log("--- index:---", index)
      console.log("--- item:---", item)
    },
    // 权益上移
    upEquity(index, item) {
      if (index == 0) {
        return
      } else {
        // 交换当前项与上一项的位置
        const temp = item.gradeEquityList[index];
        item.gradeEquityList.splice(index, 1);
        item.gradeEquityList.splice(index - 1, 0, temp);
      }
    },
    // 权益下移
    downEquity(index, item) {
      if (index == item.gradeEquityList.length - 1) {
        return
      } else {
        // 交换当前项与下一项的位置
        const temp = item.gradeEquityList[index];
        item.gradeEquityList.splice(index, 1);
        item.gradeEquityList.splice(index + 1, 0, temp);
      }
    },

    // 删除图片
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
    },
    // 图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
      this.itemListFor = this.mainImagelist;
    },

    // 添加曝光商品
    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        console.log(this.mainImagelist);
        this.selectGoodsArr = this.itemListFor;
      }
      this.selectGoodsState = false;
    },

    // 添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },

    // 曝光商品复选框勾选事件
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$forceUpdate();
    },

    // 生成规则
    generateRule() {
      let text1 = "参与方式：活动时间范围内，进入活动手动报名参与，并且会员等级在参与后发生升级；",
        text2 = "升级礼领取规则：\n(1) 领取条件：符合活动对象身份要求，且不在排除人群范围内；并且活动时间范围内，已经进入活动手动报名参与，且会员等级在参与活动后有发生升级；\n(2)领奖时效：在活动有效期内，进入活动页按提示操作可领取会员升级礼遇；\n(3) 升级礼数量有限，发完即止，具体数量以页面显示为准；",
        text6 = "",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【注意事项】";
        let levelList = this.levelList.map(item => item.name);
        const {firstText,precautions} = this.getCommonText(levelList,this.ruleForm,this.ruleDto,this.actMember)
      // 每人领奖次数限制
      if (this.ruleForm.limitPerPerson) {
        text6 = '每人领奖限制：每人限制领取' + this.ruleForm.limitPerPerson + '次奖品';
      } else {
        text6 = '每人领奖限制：不限次数，只要符合条件即可领，即连续升级等情况下可领取多个奖品；';
      }
      text6+="，超出次数，即使再升级也不能领取奖品；"
      let Arr1 = [
        firstText,
        [secondText,text1,text6,text2],
        [thirdText,precautions],
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText;
    },

    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 获取活动对象
    getAllowLevel() {
      // 因为接口没有专门的字段指定活动对象
      // 不限对象：-1 指定会员：不限对象:-1,0,1,2,3,4,5 特定会员：1,2,3 指定人群 99
      let allowLevel = ''
      if (this.actMember == 1) { // 不限
        console.log("--- this.actMember:---", this.actMember)
        allowLevel = '-1'
      } else if (this.actMember == 2) { // 指定会员
        if (this.ruleForm.partner.includes("-1")) {
          allowLevel = '-1,0,' + this.levelList.map(item => item.value).join(',')
        } else {
          allowLevel = this.ruleForm.partner.join(',')
        }
      } else { // 指定人群
        allowLevel = "99"
      }
      return allowLevel
    },
    // 获取奖品设置
    getPointActivityPrizeDTOList() {
      // 检查是否所有奖品都已设置
      console.log("--- this.prizeSettingListLevel:---", this.prizeSettingListLevel)
      for (const levelItem of this.prizeSettingListLevel) {
        // 查找未设置奖品的项
        const hasEmptyPrize = levelItem.settingList.find(setting => !setting.prizeType) || levelItem.settingList.length == 0;
        if (hasEmptyPrize) {
          // 查找对应的会员等级名称
          const level = this.levelList.find(item => item.value === hasEmptyPrize.taskIndex);
          // 显示警告信息
          if (this.isCheckedParams) { // 点击保存并完成设置时不直接返回需要执行后面的提示
            this.$message.warning(level ? `请选择${level.name}奖品` : '请选择奖品');
            return null; // 直接返回，终止后续操作
          }
        }
      }
      // 所有奖品都已设置，合并所有等级的奖品设置
      const prizeArr = [];
      this.prizeSettingListLevel.forEach(item => {
        prizeArr.push(...item.settingList.filter(v=> v.prizeType).map(prize => {
          // 提交地址限制：数组转逗号分隔字符串
          if (prize.prizeType == 3 && Array.isArray(prize.commitAddressLimit)) {
            prize.commitAddressLimit = prize.commitAddressLimit.join(',');
          }
          return prize;
        }));
      });
      return prizeArr;
    },
    // 获取memberLevelRules
    getMemberLevelRules() {
      // 检查是否所有等级条件都已设置
      // console.log("--- this.prizeSettingListLevel333:---", this.prizeSettingListLevel)
      for (const levelItem of this.prizeSettingListLevel) {
        // 查找未设置等级条件的项
        if (!levelItem.memberLevelCondition) {
          // 查找对应的会员等级名称
          const level = this.levelList.find(item => item.value === levelItem.customerLevel);
          // 显示警告信息
          if (this.isCheckedParams) { // // 点击保存并完成设置时不直接返回需要执行后面的提示
            this.$message.warning(level ? `请输入${level.name}等级条件` : '请输入等级条件');
            return null; // 直接返回，终止后续操作
          }
        } else { // 等级条件存在
          // 如果输入了跳转链接,判断跳转链接是否合规
          if (levelItem.jumpInfo) {
            const level = this.levelList.find(item => item.value === levelItem.customerLevel);
            const urlPattern = /^https?:\/\/.+/;
            const domainPattern = /\.(isvjcloud\.com|isvbjd\.com|jd\.com)/;
            if (this.isCheckedParams) { // // 点击保存并完成设置时不直接返回需要执行后面的提示
              // return null;
              if (!urlPattern.test(levelItem.jumpInfo)) {
                this.$message.warning(`${level.name}的升级链接必须以 http:// 或 https:// 开头`);
                return null;
              }
              if (!domainPattern.test(levelItem.jumpInfo)) {
                this.$message.warning(`${level.name}的升级链接必须包含 .isvjcloud.com, .isvbjd.com 或 .jd.com 域名`);
                return null;
              }
            }
          }
        }
      }
      // 所有等级条件都已设置且跳转链接合规，合并所有等级的条件
      const meRules = [];
      this.prizeSettingListLevel.forEach(item => {
        meRules.push({
          level: item.customerLevel,
          memberLevelCondition: item.memberLevelCondition,
          jumpInfo: item.jumpInfo || '',
        });
      });
      return meRules;
    },
    // 获取会员权益映射
    getActivityMemberBenifitMap() {
      const activityMemberBenifitMap = {};
      // 遍历会员等级列表
      this.prizeSettingListLevel.forEach(levelItem => {
        // 获取当前等级
        const level = levelItem.customerLevel;
        // 如果存在权益列表
        if (levelItem.gradeEquityList && levelItem.gradeEquityList.length > 0) {
          // 转换权益数据格式
          const benefitList = levelItem.gradeEquityList.map((benefit, index) => {
            return {
              activityMemberLevelBenefitRelationId: benefit.id,
              memberBenefitId: benefit.id,
              iconUrl: benefit.benefitEnableIconUrl.trim(),
              benefitEnableIconUrl: benefit.benefitEnableIconUrl,
              benefitDisableIconUrl: benefit.benefitEnableIconUrl,
              name: benefit.name,
              jumpInfo: benefit.jumpInfo.trim(),
              sort: index + 1 // 使用索引作为排序值
            };
          });

          // 将转换后的权益列表添加到映射对象中
          activityMemberBenifitMap[level] = benefitList;
        } else {
          // 如果没有权益列表，则设置为空数组
          activityMemberBenifitMap[level] = [];
        }
      });

      return activityMemberBenifitMap;
    },

    // 检查曝光商品
    checkExposureItem() {
      if (this.ruleForm.exposureSwitch) { // 勾选了曝光商品
        if (!this.itemListFor || this.itemListFor.length == 0) {
          this.$message.warning('请选择曝光商品');
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    // 检查分享标题/分享简介/分享图片
    checkShareInfo() {
      if (this.ruleForm.shareTitle && this.ruleForm.shareIntroduce && this.ruleForm.sharePic) {
        return true;
      } else {
        if (!this.ruleForm.shareTitle) {
          this.$message.warning('请输入分享标题');
          return false;
        } else if (!this.ruleForm.shareIntroduce) {
          this.$message.warning('请输入分享简介');
          return false;
        } else if (!this.ruleForm.sharePic) {
          this.$message.warning('请上传分享图片');
          return false;
        }
      }
    },
    // 保存并完成设置
    saveAndFinish() {
      this.isSaveAndFinish = true;
      // 初始化参数
      this.resetForm();
      this.isSaveAndFinish = false;
    },

    // 整合参数
    resetForm() {
      this.params = {}
      // 活动名称不能为空
      if (!this.ruleForm.activityName) {
        this.$message.warning('请输入活动名称');
        return;
      }
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType==1 &&!this.ruleForm.openCardBeforeDay
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
        if (
          this.ruleForm.firstOpenCardTimeType==2 &&
          (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }
      // 获取活动对象
      let allowLevel = this.getAllowLevel()
      // this.joinBlackList = true;
      //  自定义文案内容
      let customerPaperwork = JSON.stringify({
        ...this.customerPaperwork,
        theme: this.ruleForm.theme,
        description: this.ruleForm.description,
        wordColor: this.ruleForm.wordColor,
        shopNameType: this.ruleForm.shopNameType,
        moreActSet: this.ruleForm.moreActSet,
      });
      // 获取奖品设置
      let pointActivityPrizeDTOList = this.getPointActivityPrizeDTOList();
      console.log("--- pointActivityPrizeDTOList:---", pointActivityPrizeDTOList)
      // 奖品不完善且需要校验，中断操作
      if (!pointActivityPrizeDTOList && this.isCheckedParams && !this.isDraft) {
        return;
      }
      let memberLevelRules = this.getMemberLevelRules();
      console.log("--- memberLevelRules:---", memberLevelRules)
      // 等级条件不完善且需要校验，中断操作
      if (!memberLevelRules && this.isCheckedParams && !this.isDraft) {
        return;
      }
      let activityMemberBenifitMap = this.getActivityMemberBenifitMap();
      console.log("--- activityMemberBenifitMap:---", activityMemberBenifitMap)
      // 如果勾选了曝光商品则曝光商品必传
      if (!this.checkExposureItem() && !this.isDraft) {
        return;
      }
      // 检查分享标题/分享简介/分享图片
      if (!this.checkShareInfo() && !this.isDraft) {
        return;
      }
      // 活动规则不能为空
      if (!this.ruleForm.ruleDescription && !this.isDraft) {
        this.$message.warning('请生成活动规则');
        return;
      }
      this.ruleDto.cusTemplateJSON.customeLevelSeting = this.customeLevelSeting;
      this.params = {
        subType: 44,
        // 活动名称 
        activityName: this.ruleForm.activityName,
        // 活动开始时间 
        startTime: this.activityStartTime,
        // 活动结束时间 
        endTime: this.activityEndTime,
        // 指定身份 
        allowLevel: allowLevel,
        // 指定人群 
        crowdIds: this.peopleSelected.join(","),
        // 活动条件 
        condFollow: this.ruleForm.condFollow ? 1 : 0,
        // 是否曝光商品 
        isExposureItem: this.ruleForm.exposureSwitch,
        // 曝光商品价格显示 0：显示京东价 
        priceType: "0",
        // 曝光商品列表 
        itemList: this.itemListFor,
        ruleDTO: {
          // 小程序分享标题
          shareTitle: this.ruleForm.shareTitle,
          // 小程序分享描述
          shareIntroduce: this.ruleForm.shareIntroduce,
          // 小程序分享图片
          sharePic: this.ruleForm.sharePic,
          // 可领奖会员级别
          memberLevels: this.ruleForm.memberLevels,
          // 点击条件和条件信息 
          memberLevelRules: memberLevelRules,
          // 每人领限制 
          limitPerPerson: this.ruleForm.limitPerPerson,
          // 自定义文案内容(活动主题/活动说明/文字颜色) 1
          customerPaperwork: customerPaperwork,
          // plus会员身份 
          plusObject: this.ruleDto.plusObject,
          // 是否勾选入会时间 
          firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
          // 入会开始时间 
          openCardStartTime: this.ruleDto.openCardStartTime,
          // 入会结束时间 
          openCardEndTime: this.ruleDto.openCardEndTime,
          // 强提醒
          isForceRemind: this.ruleDto.isForceRemind,
          // 入会时间 
          openCardBeforeDay: this.ruleForm.openCardBeforeDay,
          // 开卡关注
          openCardFollow : this.ruleForm.openCardFollow,
          // 自定义等级
          cusTemplateJSON: JSON.stringify(this.ruleDto.cusTemplateJSON),
          // 是否开启黑名单
          isValidBlackList: this.ruleForm.isValidBlackList,
        },
        // 规则内容 
        ruleDescription: this.ruleForm.ruleDescription,
        // 模板Id 
        templateId: this.templateId,
        // 活动ID 
        pointActivityId: '',
        // 是否为草稿编辑
        isDraft: this.isDraftEdit,
        // 状态 
        status: 0,
        // 活动奖项集合 
        pointActivityPrizeDTOList: pointActivityPrizeDTOList,
        // 活动会员权益
        activityMemberBenifitMap: activityMemberBenifitMap,
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(','),
        studentStatus: this.ruleForm.studentStatus,
      }
      console.log(this.params,this.isDraft);
      
      // console.log("--- this.prizeSettingListLevel:---", this.prizeSettingListLevel)
      if (this.isCheckedParams) { // 需要校验
        this.joinBlackList = true;
      }
    },

    // 获取活动详情(用于回显操作)
    getDetail() {
      if (this.ids != "") {
        console.log("--- this.ids:---", this.ids)
        let id = this.ids;
        this.valueRow = {
          id: id,
        };
        getMemberLevelGift(id)
          .then((res) => {
            console.log("-获取成功-- res:---", res)
            if (res && res.code == 1) { // 执行回显操作
              // 活动名称回显
              this.ruleForm.activityName = res.data.activityName;
              // 活动开始时间回显
              this.activityStartTime = res.data.startTime;
              // 活动结束时间回显
              this.activityEndTime = res.data.endTime;
              // 是否重点活动回显
              this.isKeyActivity = res.data.isKeyActivity || 0;
              // 活动投放位置回显
              this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(',') : ["SHOP"];
              // 活动对象回显
              const all_Level = res.data.allowLevel.split(',');
              if (all_Level.length === 1 && all_Level[0] === '-1') {
                // 不限对象
                this.actMember = '1';
                this.ruleForm.partner = ['-1'];
              } else if (all_Level.length === 1 && all_Level[0] === '99') {
                // 指定人群
                this.actMember = '3';
                this.peopleSelected = res.data.crowdIds.split(',');
              } else {
                // 指定会员
                this.actMember = '2';
                // 检查是否包含全部会员
                if (all_Level.includes('-1')) {
                  this.ruleForm.partner = ['-1'];
                } else {
                  // 过滤出有效的会员等级
                  const validLevels = all_Level;
                  this.ruleForm.partner = validLevels.length > 0 ? validLevels : ['-1'];
                }
                // 判断有没有指定入会时间
                this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType || 0
                if(res.data.ruleDto.openCardStartTime&&res.data.ruleDto.openCardEndTime){
                  this.ruleForm.firstOpenCardTimeType = 2
                }

                if(this.ruleForm.firstOpenCardTimeType==1) {
                  this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay;
                }

                if (this.ruleForm.firstOpenCardTimeType==2) {
                  this.ruleDto.openCardStartTime = res.data.ruleDto.openCardStartTime;
                  this.ruleDto.openCardEndTime = res.data.ruleDto.openCardEndTime;
                }

                this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow || 0
              }
              // 强提醒
              this.ruleDto.isForceRemind = res.data.ruleDto.isForceRemind;
              // 学生身份
              this.ruleForm.studentSatus = res.data.studentSatus || "";
              // Plus会员回显
              this.ruleDto.plusObject = res.data.ruleDto.plusObject;
              this.ruleDto.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON && JSON.parse(res.data.ruleDto.cusTemplateJSON) || {};
              this.customeLevelSeting = this.ruleDto.cusTemplateJSON.customeLevelSeting || [];
              // 活动条件回显
              if (res.data.condFollow) {
                this.ruleForm.condFollow = true;
              } else {
                this.ruleForm.condFollow = false;
              }
              // 可领奖等级回显
              this.ruleForm.memberLevels = res.data.ruleDto.memberLevels;
              // 处理奖品回显
              if (res.data.pointActivityPrizeDTOList && res.data.pointActivityPrizeDTOList.length) {
                // 统一处理奖品地址限制回显：逗号分隔字符串转数字数组
                res.data.pointActivityPrizeDTOList = res.data.pointActivityPrizeDTOList.map((item) => {
                  if (item.prizeType == 3) {
                    if (item.commitAddressLimit) {
                      item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                        ? item.commitAddressLimit.split(',').map(Number)
                        : item.commitAddressLimit;
                    } else {
                      item.commitAddressLimit = [0];
                    }
                  }
                  return item;
                });
                // 全部
                let levelArr = []
                if (this.ruleForm.memberLevels.includes("-1")) {
                  levelArr = this.levelList
                } else {
                  levelArr = this.levelList.filter(item => this.ruleForm.memberLevels.includes(item.value))
                }
                this.prizeSettingListLevel = levelArr.map((item) => {
                  const obj = {
                    customerLevel: item.value,
                    name: item.name,
                    settingList: [],
                    // 初始化会员等级条件和跳转链接
                    memberLevelCondition: '',
                    jumpInfo: ''
                  }
                  // 处理奖品数据
                  res.data.pointActivityPrizeDTOList.forEach(list => {
                    if (item.value == list.taskIndex) {
                      obj.settingList.push({ ...list, minNum: item.totalAmount })
                    }
                  })
                  // 处理会员等级条件和跳转链接回显
                  if (res.data.ruleDto && res.data.ruleDto.memberLevelRules && res.data.ruleDto.memberLevelRules.length) {
                    const levelRule = res.data.ruleDto.memberLevelRules.find(rule => rule.level === item.value);
                    if (levelRule) {
                      obj.memberLevelCondition = levelRule.memberLevelCondition || '';
                      obj.jumpInfo = levelRule.jumpInfo || '';
                    }
                  }
                  return obj
                });
              }
              // 会员等级权益回显
              if (res.data.activityMemberBenifitMap) {
                console.log("会员权益数据:", res.data.activityMemberBenifitMap);

                // 遍历会员等级列表
                this.prizeSettingListLevel.forEach(levelItem => {
                  const level = levelItem.customerLevel;
                  // 初始化权益列表 - 使用 $set 确保响应式
                  this.$set(levelItem, 'gradeEquityList', []);

                  // 如果存在该等级的权益数据
                  if (res.data.activityMemberBenifitMap[level] && res.data.activityMemberBenifitMap[level].length > 0) {
                    // 按照sort排序
                    const sortedBenefits = [...res.data.activityMemberBenifitMap[level]].sort((a, b) => a.sort - b.sort);

                    // 转换权益数据格式并使用 $set 更新
                    this.$set(levelItem, 'gradeEquityList', sortedBenefits.map(benefit => {
                      return {
                        id: benefit.memberBenefitId,
                        activityMemberLevelBenefitRelationId: benefit.activityMemberLevelBenefitRelationId,
                        name: benefit.name,
                        benefitEnableIconUrl: benefit.iconUrl,
                        benefitDisableIconUrl: benefit.iconUrl,
                        jumpInfo: benefit.jumpInfo || '',
                        sort: benefit.sort
                      };
                    }));
                  }
                });

                // 更新已选择权益列表(用于回显)
                this.selectedEquities = [];
                Object.values(res.data.activityMemberBenifitMap).forEach(benefitList => {
                  benefitList.forEach(benefit => {
                    this.selectedEquities.push({
                      id: benefit.memberBenefitId,
                      name: benefit.name,
                      benefitEnableIconUrl: benefit.iconUrl,
                      benefitDisableIconUrl: benefit.iconUrl,
                      jumpInfo: benefit.jumpInfo || ''
                    });
                  });
                });

                console.log("会员权益回显完成:", this.prizeSettingListLevel);
              }
              // 每人领奖限制回显
              this.ruleForm.limitPerPerson = res.data.ruleDto.limitPerPerson;
              // 活动主题回显
              let backcustomerPaperwork = JSON.parse(res.data.ruleDto.customerPaperwork);
              this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {};
              this.ruleForm.theme = backcustomerPaperwork.theme || '';
              // 活动说明回显
              this.ruleForm.description = backcustomerPaperwork.description || '';
              // 文字颜色回显
              this.ruleForm.wordColor = backcustomerPaperwork.wordColor || '#1A1A1A';
              // 活动页设置
              this.ruleForm.shopNameType = backcustomerPaperwork.shopNameType || 0;
              // 更多活动设置回显
              this.ruleForm.moreActSet = backcustomerPaperwork.moreActSet || {
                isShowFloatWindow: 0, //是否显示活动浮窗：0-不显示，1-显示
                floatWindowImg: "", //活动浮窗图
                goShopSetting: 0, //活动浮窗跳转设置：0-不跳转，1-跳转
                goShopAppId: "", //活动浮窗跳转小程序ID
                goShopUrl: "",
                isShowBanner: 0, //是否显示活动banner：0-不显示，1-显示
                bannerList: [],
              };
              // 曝光商品回显
              if (res.data.isExposureItem) {
                this.ruleForm.exposureSwitch = true;
                this.itemListFor = res.data.itemList;
                this.mainImagelist = res.data.itemList;
                this.selectGoodsArr = res.data.itemList;
              } else {
                this.ruleForm.exposureSwitch = false;
              }
              // 小程序分享标题回显
              this.ruleForm.shareTitle = res.data.ruleDto.shareTitle || '';
              // 小程序分享描述回显
              this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce || '';
              // 小程序分享图片回显
              this.ruleForm.sharePic = res.data.ruleDto.sharePic;
              // 规则内容回显
              this.ruleForm.ruleDescription = res.data.ruleDescription || '';
              // 黑名单回显
              this.ruleForm.isValidBlackList = res.data.ruleDto.isValidBlackList;
              // 获取模板ID
              this.templateId = res.data.templateId;
              if (res.data.templateJson) {
                this.templateId = JSON.parse(res.data.templateJson).id;
              }
              console.log("-re--  this.templateId:---", this.templateId)
              // 如果是复制则不需要回显活动时间和活动规则
              if (this.activityData.isCopy) {
                this.activityTimeChange({ startTime: this.$getDate(30)[0], endTime: this.$getDate(30)[1] });
                this.ruleForm.ruleDescription = '';
              }
            }
          })
          .catch((res) => { });
      } else {
        console.log("ids为空");
        // 设置默认时间
        if (!this.valueRow) {
          this.activityTimeChange({ startTime: this.$getDate(30)[0], endTime: this.$getDate(30)[1] });
        }
      }
    },

    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.resetForm()
          this.handleDialogCloseAnoth()
        })
      } else {
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.resetForm()
          this.handleDialogCloseAnoth()
        })
      }
    },

    // 确认保存活动
    async handleDialogCloseAnoth() {
      if (this.activityData.isStart) { // 如果活动已经开始则调用另一个接口更新数据
        this.upDateActive()
        return;
      }

      // 如果勾选了检查或点击存草稿
      if (this.checked == true || this.isDraft) {
        // 如果为新建活动, 或者保存草稿, 或者编辑草稿
        if (this.ids == "" || this.isDraft || this.isDraftEdit) {
          // 草稿箱
          if (this.isDraft) {
            this.params.status = 5
          }else if(this.isDraftEdit) {
            // 草稿箱-创建任务
            delete this.params.status;
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            this.params.id = this.valueRow.id
          }
          // 复制活动
          if (this.activityData.isCopy) {
            delete this.params.pointActivityId
          }
        } else {
          // 编辑活动
          this.params.pointActivityId = this.ids;
        }
        // 如果是复制去掉活动id
        if (this.activityData.isCopy) {
          this.params.pointActivityId = "";
        }
        console.log("--- this.params:---", this.params)
        // 创建/编辑活动
        saveMemberLevelGift(this.params).then((res) => {
          if (res && res.code == 1) {
            console.log("--- res:---", res)
            if (this.isDraft) {
              this.$message.success("保存成功！")
              this.$emit("returnBack", true);
            } else {
              // 跳转到创建成功页面
              this.joinBlackList = false;
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            }
            this.$message.success("保存成功");
            this.$emit("saveSuccess");
          } else {
            this.$message.error(res.message);
          }
        }).catch((res) => { })
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }

    },
    // 更新进行中的活动
    async upDateActive() {
      let prizes = []; // 已有的奖品列表(用于更新库存)
      let addPrizeDTOList = [] // 新增的奖品列表(用于新增)
      let updatamemberLevelRules = this.getMemberLevelRules() // 会员等级规则(存等级条件和跳转链接)
      let updataMemberBenifitMap = this.getActivityMemberBenifitMap() // 会员等级权益
      let flag = true;
      // 遍历会员等级列表
      this.prizeSettingListLevel.forEach(levelItem => {
        // 遍历每个等级的奖品设置列表
        if (levelItem.settingList && levelItem.settingList.length > 0) {
          levelItem.settingList.forEach(prize => {
            // 判断是否有id字段
            if (prize.id) {
              // 有id，放入prizes数组
              prizes.push({
                title:prize.title,
                prizeId: prize.id,
                totalAmount: prize.totalAmount,
                highLevelGetFlag: prize.highLevelGetFlag,
                taskIndex: levelItem.customerLevel,
                downgradeGetFlag: prize.downgradeGetFlag,
                upgradeGetFlag: prize.upgradeGetFlag,
              });
            } else {
              if (prize.totalAmount == 0 || prize.totalAmount == '' || !prize.totalAmount) {
                flag = false;
                this.$message.warning("新增奖品数量不能为空");
                return;
              }
              // 没有id，放入addPrizeDTOList数组
              addPrizeDTOList.push(prize);
            }
          });
        }
      });

      if (!flag) {
        return;
      }
      let updateCustomerPaperwork = JSON.stringify({
        ...this.customerPaperwork,
        theme: this.ruleForm.theme,
        description: this.ruleForm.description,
        wordColor: this.ruleForm.wordColor,
        shopNameType: this.ruleForm.shopNameType,
        moreActSet: this.ruleForm.moreActSet,
      });
      this.ruleDto.cusTemplateJSON.customeLevelSeting = this.customeLevelSeting;
      let updateRuleDto = {
        // 小程序分享标题
        shareTitle: this.ruleForm.shareTitle,
        // 小程序分享描述
        shareIntroduce: this.ruleForm.shareIntroduce,
        // 小程序分享图片
        sharePic: this.ruleForm.sharePic,
        // 可领奖会员级别
        memberLevels: this.ruleForm.memberLevels,
        // 点击条件和条件信息 
        memberLevelRules: updatamemberLevelRules, // 会员等级规则(存等级条件和跳转链接)
        // 每人领限制 
        limitPerPerson: this.ruleForm.limitPerPerson,
        // 自定义文案内容(活动主题/活动说明/文字颜色) 1
        customerPaperwork: updateCustomerPaperwork,
        // plus会员身份 
        plusObject: this.ruleDto.plusObject,
        // 是否勾选入会时间 
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        // 入会开始时间 
        openCardStartTime: this.ruleDto.openCardStartTime,
        // 入会结束时间 
        openCardEndTime: this.ruleDto.openCardEndTime,
        // 强提醒
        isForceRemind: this.ruleDto.isForceRemind,
        // 开卡关注
        openCardFollow: this.ruleForm.openCardFollow,
        cusTemplateJSON: JSON.stringify(this.ruleDto.cusTemplateJSON),
      }
      // console.log('已有奖品:', prizes);
      // console.log('新增奖品:', addPrizeDTOList);
      let params = {
        activityId: this.ids,
        activityName: this.ruleForm.activityName, // 活动名称
        condFollow: this.ruleForm.condFollow ? 1 : 0, // 活动条件
        ruleDescription: this.ruleForm.ruleDescription, // 规则内容
        activityMemberBenifitMap: updataMemberBenifitMap, // 会员等级权益
        prizes, // 更新库存
        addPrizeDTOList, // 新增奖品
        ruleDto: updateRuleDto, // 更新分享设置
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
        itemList: this.itemListFor, // 曝光商品列表
        endTime: this.activityEndTime,
        templateId: this.templateId,
      };
      // if (this.actEndTime != this.activityEndTime) {
      //   params.endTime = this.activityEndTime
      // }
      console.log("--- params:---", params)
      updateCommon(params).then((res) => {
        if (res && res.code == 1) {
          console.log("--- res:---", res)
          this.$message.success("保存成功");
          // 跳转到创建成功页面
          this.joinBlackList = false;
          this.$router.push({
            name: "throw",
            query: {
              id: res.data.id,
              activityType: res.data.activityType,
            },
          });
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 活动时间改变
    activityTimeChange(timeData) {
      this.activityStartTime = timeData.startTime;
      this.activityEndTime = timeData.endTime;
      this.ruleForm.startTime = this.activityStartTime;
      this.ruleForm.endTime = this.activityEndTime;
      this.$nextTick(() => {
        if (this.ruleForm.endTime && this.ruleForm.startTime) {
          let nowTime = new Date().getTime();
          let start = new Date(this.ruleForm.startTime).valueOf();
          let end = new Date(this.ruleForm.endTime).valueOf();
          let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
          let hdInvalidateDate = new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf();
          this.timeDay = Math.floor(
            Math.abs(new Date(this.ruleForm.endTime) - new Date(this.ruleForm.startTime))
            / 1000 / 60 / 60 / 24);
          //计算小时
          const date3 = new Date(this.ruleForm.endTime).getTime() - new Date(this.ruleForm.startTime).getTime();
          const leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          // 查看不需要校验
          if (!this.backgroundOpacity) {
            if (start < nowTime) {
              if (this.ids) {
                this.disableTime = true;
              } else {
              }
            }
            if (end < nowTime) {
              this.$message.warning("结束时间不能小于当前时间");
            }
            if (end < start) {
              this.$message.warning("结束时间不能小于开始时间");
              return;
            }
            if (end > invalidateDate) {
              this.$message.warning("活动时间不能超过软件有效期，请重新选择");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
            if (end > hdInvalidateDate) {
              this.$message.warning("活动时间不可超过互动数据授权有效期！");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
          }
        }
      });
    },
    //清空时间(活动时间)
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      this.activityStartTime = null
      this.activityEndTime = null
    },
    // 返回上一步
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
    },
    // 添加奖项-会员
    addSetting(item) {
      console.log("--- item:---", item)
      if (item.settingList.length > 4)
        return this.$message.warning("最多只能设置5个奖品");
      item.settingList.push({
        taskIndex: String(item.customerLevel),
        prizeType: null,
        price: null,
        totalAmount: null,
        percentage: null,
        // 领取设置
        highLevelGetFlag: true,
        upgradeGetFlag: true,
        downgradeGetFlag: true,
      });
    },
    // 删除
    deleteSetting(index, item) {
      // 会员
      if (item) {
        item.settingList.splice(index, 1);
      } else {
        this.prizeSettingList.splice(index, 1);
      }
    },
    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    },
    // 奖品上移
    upLvGoods(index, row) {
      row.settingList[index].sort -= 1;
      let target = row.settingList.splice(
        index - 1,
        1,
        row.settingList[index]
      )[0];
      target.sort += 1;
      this.$set(row.settingList, index, target);
    },
    // 奖品下移
    downLvGoods(index, row) {
      row.settingList[index].sort += 1;
      let target = row.settingList.splice(
        index + 1,
        1,
        row.settingList[index]
      )[0];
      target.sort -= 1;
      this.$set(row.settingList, index, target);
    },
    // 上传奖品图片
    upPrizeImage(imageUrl, row) {
      console.log("--- 上传奖品图片:---", imageUrl, row);
      // 找到对应的等级和奖品设置
      if (imageUrl) {
        this.$set(row, 'logo', imageUrl);
      }
    },
    // 增加库存
    addCount(index, row) {
      this.addStockVisible = true;
      this.currentPrizeIndex = index;
      this.currentPrizeRow = row;
      this.addStockForm.addAmount = '';
    },
    // 确认增加库存
    confirmAddStock() {
      const amount = Number(this.addStockForm.addAmount);
      if (isNaN(amount) || amount <= 0) {
        this.$message.warning('请输入大于0的数字');
        return;
      }
      if (amount > 999999) {
        this.addStockForm.addAmount = '999999';
        this.$message.warning('增加数量不能超过999999');
        return;
      }
      if (!this.addStockForm.addAmount || isNaN(this.addStockForm.addAmount) || this.addStockForm.addAmount <= 0) {
        this.$message.error('请输入有效的增加数量');
        return;
      }
      // 检测奖品库存是否足够
      checkPrizeStock({
        couponType: this.currentPrizeRow == 1 ? this.currentPrizeRow.couponType : undefined,
        prizeType: this.currentPrizeRow.prizeType,
        assetsId: this.currentPrizeRow.assetsId || this.currentPrizeRow.id,
        needNum: this.addStockForm.addAmount
      }).then((res) => {
        if (res.code == 1) {
          // 更新奖品库存
          const originalAmount = Number(this.currentPrizeRow.totalAmount) || 0;
          const addAmount = Number(this.addStockForm.addAmount) || 0;
          this.currentPrizeRow.totalAmount = originalAmount + addAmount;
          this.currentPrizeRow.remanentAmount += addAmount;
          this.addStockVisible = false;
        } else {
          this.$message.error("新增数量不能大于该奖品的剩余数量！")
        }
      })
    },
    //重置文字颜色
    textColorReset() {
      this.ruleForm.wordColor = "#1A1A1A";
    },
    publicOpen() {
      publicOpen().then((res) => {
        if (res.message) {
          this.jdCrm.endTime = res.message;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.prosi {
  position: absolute;
  bottom: 107px;
  right: 38px;
}

.secondstep {
  box-sizing: border-box;
  position: relative;
  padding: 0px 28px 1px 24px;
  margin-bottom: 29px;

  /deep/ .el-table .el-table__header-wrapper th .cell {
    text-align: center;
    font-weight: 500;
  }

  /deep/ .el-table .el-table__header-wrapper th {
    border-right: 1px solid #f0f0f0;

    &:last-child {
      border-right: none;
    }
  }

  /deep/ .el-table--enable-row-transition .el-table__body td {
    text-align: center;
    border-right: 1px solid #f0f0f0;

    &:last-child {
      border-right: none;
    }
  }
}


.add_btn1 {
  cursor: pointer;
  color: #2768ff;
  border: 1px solid #2768ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}

/deep/ .el-table__body-wrapper {
  // overflow: visible !important;
}

.margin-t16 {
  margin-top: 16px;
}

.rule-tip {
  margin-top: 8px;
}

.act-tip {
  white-space: nowrap;
  color: #ff0000;
}
.setting-level {
  display: flex;
  align-items: center;

  &-item {
    cursor: pointer;
    padding: 5px 14px;
    font-size: 14px;
    color: #999999;
    text-align: center;
    background: #f8f9fc;
    margin-right: 4px;
    border-bottom: 4px solid #ffffff;
    border-radius: 4px 4px 0 0;

    &__active {
      color: #2768ff;
      border-bottom: 4px solid #f8f9fc;
    }
  }
}
.custome-level {
  width: 600px;
  background: #f8f9fc;
  padding: 20px;
  border-radius: 4px;
  .custome-level-item {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    .customebtn-box {
      background: #ffffff;
      padding: 10px;
      border-radius: 4px;
    }
    &>span {
      color: #565960;
    }
  }
}
</style>
